import {
  CREATE_CURRICULUM,
  CREATE_CURRICULUM_SUCCESS,
  CREATE_CURRICULUM_FAILURE,
  GET_CURRICULUM_LIST,
  GET_CURRICULUM_LIST_SUCCESS,
  GET_CURRICULUM_LIST_FAILURE,
  UPDATE_CURRICULUM,
  UPDATE_CURRICULUM_SUCCESS,
  UPDATE_CURRICULUM_FAILURE,
  VIEW_CURRICULUM,
  VIEW_CURRICULUM_SUCCESS,
  VIEW_CURRICULUM_FAILURE,
  UPDATE_STATUS_CURRICULUM,
  UPDATE_STATUS_CURRICULUM_SUCCESS,
  UPDATE_STATUS_CURRICULUM_FAILURE,
  GET_ACTIVE_CURRICULUM_LIST,
  GET_ACTIVE_CURRICULUM_LIST_SUCCESS,
  GET_ACTIVE_CURRICULUM_LIST_FAILURE,
} from "../types";

export const createCurriculum = (payload) => ({
  type: CREATE_CURRICULUM,
  payload,
});

export const createCurriculumSuccess = (payload) => ({
  type: CREATE_CURRICULUM_SUCCESS,
  payload,
});

export const createCurriculumFailure = (payload) => ({
  type: CREATE_CURRICULUM_FAILURE,
  payload,
});

export const getCurriculumList = (payload) => ({
  type: GET_CURRICULUM_LIST,
  payload,
});

export const getCurriculumListSuccess = (payload) => ({
  type: GET_CURRICULUM_LIST_SUCCESS,
  payload,
});

export const getCurriculumListFailure = (payload) => ({
  type: GET_CURRICULUM_LIST_FAILURE,
  payload,
});

export const updateCurriculum = (payload) => ({
  type: UPDATE_CURRICULUM,
  payload,
});

export const updateCurriculumSuccess = (payload) => ({
  type: UPDATE_CURRICULUM_SUCCESS,
  payload,
});

export const updateCurriculumFailure = (payload) => ({
  type: UPDATE_CURRICULUM_FAILURE,
  payload,
});

export const updateStatusCurriculum = (payload) => ({
  type: UPDATE_STATUS_CURRICULUM,
  payload,
});

export const updateStatusCurriculumSuccess = (payload) => ({
  type: UPDATE_STATUS_CURRICULUM_SUCCESS,
  payload,
});

export const updateStatusCurriculumFailure = (payload) => ({
  type: UPDATE_STATUS_CURRICULUM_FAILURE,
  payload,
});

export const viewCurriculum = (payload) => ({
  type: VIEW_CURRICULUM,
  payload,
});

export const viewCurriculumSuccess = (payload) => ({
  type: VIEW_CURRICULUM_SUCCESS,
  payload,
});

export const viewCurriculumFailure = (payload) => ({
  type: VIEW_CURRICULUM_FAILURE,
  payload,
});

export const getActiveCurriculumList = (payload) => ({
  type: GET_ACTIVE_CURRICULUM_LIST,
  payload,
});

export const getActiveCurriculumListSuccess = (payload) => ({
  type: GET_ACTIVE_CURRICULUM_LIST_SUCCESS,
  payload,
});


export const getActiveCurriculumListFailure = (payload) => ({
  type: GET_ACTIVE_CURRICULUM_LIST_FAILURE,
  payload,
});